import types from './types';

export const getSliderImages = () => ({
    type: types.GET_SLIDER_IMAGES
});

export const getSliderImagesSuccess = (payload) => ({
    type: types.GET_SLIDER_IMAGES_SUCCESS,
    payload
});

export const getSliderImagesFailure = (payload) => ({
    type: types.GET_SLIDER_IMAGES_FAILURE,
    payload
});
